import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '@core/components/toasts/toasts.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ReproveAbsenceDialogComponent } from '../reprove-absence-dialog/reprove-absence-dialog.component';
import { TimeOccurrenceService } from 'services/corporate/timeOccurrence.service';
import { TimeOccurrenceModel } from 'services/models/corporate/timeOccurrence.model';

@Component({
  selector: 'app-occurrence-document-preview',
  templateUrl: './occurrence-document-preview.component.html',
  styleUrls: ['./occurrence-document-preview.component.scss'],
})
export class OccurrenceDocumentPreviewModalComponent implements OnInit {

  timeOccurrenceId: string = '';
  timeOccurrence: TimeOccurrenceModel = new TimeOccurrenceModel();
  isLoading = false;
  documentPreviewUrl: SafeResourceUrl | null = null;
  mimeType: string | null = null;
  
  constructor(
    private formBuilder: UntypedFormBuilder,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private _modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private _sanitizer: DomSanitizer,
    private _toastr: ToastService,
    private service: TimeOccurrenceService,
  ) { }

  ngOnInit(): void {
    this.getOccurrence();
  }

  getOccurrence() {
    this.service.get(this.timeOccurrenceId).subscribe((res) => {
      this.timeOccurrence = res.data;
      this.loadDocumentPreview();
    });
  }

  private loadDocumentPreview() {
    this.service.getContent(this.timeOccurrence.fileKey, this.timeOccurrence.fileName.toLowerCase())
      .subscribe((response: any) => {
			this.mimeType = response.headers?.get("content-type") || "application/octet-stream";
			const blobUrl = URL.createObjectURL(new Blob([response.body], { type: this.mimeType }));

			this.documentPreviewUrl = this._sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    }, (error) => {
			console.error("Erro ao carregar o documento para visualização", error);

			this.documentPreviewUrl = null;
    });
	}

  isPdf(): boolean {
    return this.mimeType === 'application/pdf';
  }
  
  isImage(): boolean {
    return this.mimeType?.startsWith('image/');
  }

  setLoadSpinner(state: boolean) {
    this.isLoading = state;
  }

  openReproveAbsence() {
    const modalRef = this._modalService.open(ReproveAbsenceDialogComponent, {
      windowClass: 'confirm-dialog-modal',
      backdropClass: 'confirm-dialog-backdrop'
    });

    modalRef.closed.subscribe((submit) => {
      if (submit === false) return;
      const toRequest: any = {
        id: this.timeOccurrence.id,
        reproveReason: modalRef.componentInstance.reproveReason.trim().length > 0 ? modalRef.componentInstance.reproveReason : "Não informado"
      };
      this.isLoading = true;
      this.service.revertTimeOccurrence(toRequest).subscribe(
        () => {
          this._toastr.showSuccess("Tratamento de Ocorrência revertido com sucesso!");
          this.onDismiss(true);
          this.isLoading = false;
        },
        (err) => { this.isLoading = false; }
      );
    });
  }

  onDismiss(submit): void {
    this.activeModal.close(submit);
  }
}
